import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  validateIdentityGeneralApi, validateAniApi, validateMuiscaApi,
  getQuestionnaireCFApi, evaluateQuestionnaireCFApi, consultStatusCFApi
} from './identityAPI';

const initialState = {
  statusValidateIdentityGeneral: "idle",
  dataValidateIdentityGeneral: "",
  messageValidateIdentityGeneral: "",

  statusValidateAni: "idle",
  dataValidateAni: "",
  messageValidateAni: "",

  statusValidateMuisca: "idle",
  dataValidateMuisca: "",
  messageValidateMuisca: "",

  statusConsultStatusCF: "idle",
  consultStatusCFData: "",
  messageConsultStatusCF: "",

  statusgetCF: "idle",
  dataGetCF: "",
  dataErrorGetCF: "",
  messageGetCF: "",

  statusEvaluateCF: "idle",
  dataEvaluateCF: "",
  messageEvaluateCF: ""

};

export const validateIdentityGeneral = createAsyncThunk(
  '/identity/validateIdentityGeneral',
  async (data) => {
    const response = await validateIdentityGeneralApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const validateAni = createAsyncThunk(
  '/identity/validateAni',
  async (data) => {
    const response = await validateAniApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const validateMuisca = createAsyncThunk(
  '/identity/validateMuisca',
  async (data) => {
    const response = await validateMuiscaApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const consultStatusCF = createAsyncThunk(
  '/identity/consultStatusCF',
  async (data) => {
    const response = await consultStatusCFApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getQuestionnaireCF = createAsyncThunk(
  '/identity/getQuestionnaireCF',
  async (data) => {
    const response = await getQuestionnaireCFApi(data);
    if (response.status === 'error') {
      throw ({ message: response.data.message })
    }
    return response.data;
  }
);

export const evaluateQuestionnaireCF = createAsyncThunk(
  '/identity/evaluateQuestionnaireCF',
  async (data) => {
    const response = await evaluateQuestionnaireCFApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);



export const identitySlice = createSlice({
  name: 'identity',
  initialState,
  reducers: {
    reset: () => initialState,
    clearValidateIdentityGeneral: (state) => {
      state.statusValidateIdentityGeneral = "idle";
      state.dataValidateIdentityGeneral = "";
      state.messageValidateIdentityGeneral = "";
      state.statusgetCF = "idle";
      state.dataGetCF = "";
      state.messageGetCF = "";
      state.statusEvaluateCF = "idle";
      state.dataEvaluateCF = "";
      state.messageEvaluateCF = "";
      state.statusConsultStatusCF = "idle";
      state.consultStatusCFData = "";
      state.messageConsultStatusCF = "";
    },
    clearsEvaluateCF: (state) => {
      state.statusEvaluateCF = "idle";
      state.dataEvaluateCF = "";
      state.messageEvaluateCF = "";
    },
  },
  extraReducers: (builder) => {
    builder
      //Reducer para validacion general
      .addCase(validateIdentityGeneral.pending, (state) => {
        state.statusValidateIdentityGeneral = 'loading';
      })
      .addCase(validateIdentityGeneral.fulfilled, (state, action) => {
        state.statusValidateIdentityGeneral = 'fulfilled';
        state.dataValidateIdentityGeneral = action.payload;
      })
      .addCase(validateIdentityGeneral.rejected, (state, action) => {
        state.statusValidateIdentityGeneral = 'rejected';
        state.messageValidateIdentityGeneral = action.error.message;
      })
      //Reducer para validateAni
      .addCase(validateAni.pending, (state) => {
        state.statusValidateAni = 'loading';
      })
      .addCase(validateAni.fulfilled, (state, action) => {
        state.statusValidateAni = 'fulfilled';
        state.dataValidateAni = action.payload;
      })
      .addCase(validateAni.rejected, (state, action) => {
        state.statusValidateAni = 'rejected';
        state.messageValidateAni = action.error.message;
      })
      //Reducer para validateMuisca
      .addCase(validateMuisca.pending, (state) => {
        state.statusValidateMuisca = 'loading';
      })
      .addCase(validateMuisca.fulfilled, (state, action) => {
        state.statusValidateMuisca = 'fulfilled';
        state.dataValidateMuisca = action.payload;
      })
      .addCase(validateMuisca.rejected, (state, action) => {
        state.statusValidateMuisca = 'rejected';
        state.dataValidateMuisca = action.payload;
        state.messageValidateMuisca = action.error.message;
      })
      //Reducer para consultStatusCF
      .addCase(consultStatusCF.pending, (state) => {
        state.statusConsultStatusCF = 'loading';
      })
      .addCase(consultStatusCF.fulfilled, (state, action) => {
        state.statusConsultStatusCF = 'fulfilled';
        state.consultStatusCFData = action.payload;
      })
      .addCase(consultStatusCF.rejected, (state, action) => {
        state.statusConsultStatusCF = 'rejected';
        // state.consultStatusCFData = action.payload;
        state.messageConsultStatusCF = action.error.message;
      })
      //Reducer para obtenerCuestionario
      .addCase(getQuestionnaireCF.pending, (state) => {
        state.statusgetCF = 'loading';
      })
      .addCase(getQuestionnaireCF.fulfilled, (state, action) => {
        state.statusgetCF = 'fulfilled';
        state.dataGetCF = action.payload;
        state.messageGetCF = action.payload.message;

      })
      .addCase(getQuestionnaireCF.rejected, (state, action) => {
        state.statusgetCF = 'rejected';
        state.dataErrorGetCF = action.error;
        state.messageGetCF = action.error.message;
      })
      //Reducer para evaluarCuestionario
      .addCase(evaluateQuestionnaireCF.pending, (state) => {
        state.statusEvaluateCF = 'loading';
      })
      .addCase(evaluateQuestionnaireCF.fulfilled, (state, action) => {
        state.statusEvaluateCF = 'fulfilled';
        state.dataEvaluateCF = action.payload;
      })
      .addCase(evaluateQuestionnaireCF.rejected, (state, action) => {
        state.statusEvaluateCF = 'rejected';
        state.messageEvaluateCF = action.error.message;
      })
  },
});

export const { reset, clearValidateIdentityGeneral, clearsEvaluateCF } = identitySlice.actions;

export const selectStatusValidateIdentityGeneral = (state) => state.identity.statusValidateIdentityGeneral;
export const selectDataValidateIdentityGeneral = (state) => state.identity.dataValidateIdentityGeneral;
export const selectMessageValidateIdentityGeneral = (state) => state.identity.messageValidateIdentityGeneral;

export const selectStatusValidateAni = (state) => state.identity.statusValidateAni;
export const selectDataValidateAni = (state) => state.identity.dataValidateAni;
export const selectMessageValidateAni = (state) => state.identity.messageValidateAni;

export const selectStatusValidateMuisca = (state) => state.identity.statusValidateMuisca;
export const selectDataValidateMuisca = (state) => state.identity.dataValidateMuisca;
export const selectMessageValidateMuisca = (state) => state.identity.messageValidateMuisca;

export const selectStatusConsultStatusCF = (state) => state.identity.statusConsultStatusCF;
export const selectConsultStatusCFData = (state) => state.identity.consultStatusCFData;
export const selectMessageConsultStatusCF = (state) => state.identity.messageConsultStatusCF;

export const selectStatusgetCF = (state) => state.identity.statusgetCF;
export const selectDataGetCF = (state) => state.identity.dataGetCF;
export const selectDataErrorGetCF = (state) => state.identity.dataErrorGetCF;
export const selectMessageGetCF = (state) => state.identity.messageGetCF;

export const selectStatusEvaluateCF = (state) => state.identity.statusEvaluateCF;
export const selectDataEvaluateCF = (state) => state.identity.dataEvaluateCF;
export const selectMessageEvaluateCF = (state) => state.identity.messageEvaluateCF;

export default identitySlice.reducer;
